import axios from "axios";

const IMPRESSION_KEY = "promo_feedback_impressions";
const CLICK_KEY = "promo_feedback_clicks";

/**
 * Track impressions for a list of promo events.
 * Session-deduplicated by event ID: each event is only reported once per browser session.
 * The backend additionally guards against duplicate counts via WishlistItemEvent.impressed.
 *
 * @param {{event_id: number, phrases: string[]}[]} events - Array of {event_id, phrases} objects
 */
export async function trackImpressions(events) {
    const seen = JSON.parse(sessionStorage.getItem(IMPRESSION_KEY) || "[]");
    const newEvents = events.filter((e) => !seen.includes(e.event_id));
    if (newEvents.length === 0) return;

    try {
        await axios.post("feedback/impression", { events: newEvents });
        sessionStorage.setItem(
            IMPRESSION_KEY,
            JSON.stringify([...seen, ...newEvents.map((e) => e.event_id)])
        );
    } catch {
        // silently ignore — feedback failures should not interrupt the UX
    }
}

/**
 * Track clicks on one or more promo phrases for a specific wishlist item event.
 * Session-deduplicated by event ID: each event is only reported once per browser session.
 * The backend additionally guards against duplicate counts via WishlistItemEvent.clicked.
 *
 * @param {string|string[]} phrases - One or more matched_text strings that were clicked
 * @param {number} eventId - The wishlist item event ID the click belongs to
 */
export async function trackClick(phrases, eventId) {
    const list = Array.isArray(phrases) ? phrases : [phrases];
    const seen = JSON.parse(sessionStorage.getItem(CLICK_KEY) || "[]");
    if (seen.includes(eventId)) return;

    try {
        await axios.post("feedback/click", {
            phrases: list,
            event_id: eventId,
        });
        sessionStorage.setItem(CLICK_KEY, JSON.stringify([...seen, eventId]));
    } catch {
        // silently ignore — feedback failures should not interrupt the UX
    }
}
